
import {
    TABLE_LOAD_TABLES,
    TABLE_LOAD_NEWS,
    TABLE_LOAD_SPONSORS,
    TABLE_LOAD_HELP,
    TABLE_LOAD_NAB,
    TABLE_LOAD_SPEAKERS,
    TABLE_LOAD_SPEAKER,
    TABLE_LOAD_EVENT
} from "./actions";











  
 





const defaultState = {
    events : [],
    event : null,
    news : [],
    sponsors :[],
    help : null,
    nab: null,
    speaker : null,
    speaker_: null
}

const tableReducer = (state = defaultState, action) => {

        switch(action.type) {
            case TABLE_LOAD_TABLES:
                return {
                    ...state,
                    events: action.payload
                
                   
                }
                case TABLE_LOAD_NEWS:
                return {
                    ...state,
                    news: action.payload1
                
                   
                }
                case TABLE_LOAD_SPONSORS:
                return {
                    ...state,
                    sponsors: action.payload2
                
                   
                }
                case TABLE_LOAD_HELP:
                return {
                    ...state,
                    help: action.payload3
                
                   
                }
                case TABLE_LOAD_NAB:
                    return {
                        ...state,
                        nab: action.payload4
                    
                       
                    }
                    case TABLE_LOAD_SPEAKERS:
                    return {
                        ...state,
                        speaker: action.payload5
                    
                       
                    }
                    case TABLE_LOAD_SPEAKER:
                        return {
                            ...state,
                            speaker_: action.payload6
                        
                           
                        }
                        case TABLE_LOAD_EVENT:
                        return {
                            ...state,
                            event: action.payload7
                        
                           
                        }
            default: return state
            }
        }

export default tableReducer